import React from 'react';
import classes from './BookMeal.module.scss';
import Modal from '../ApplyLeave/Modal';


const MealType = ({ name, type, func }) => {
    return (
        <div className={classes.MealTypeDiv}>
            <h2>
                {name}
            </h2>
            <h1>
                0
            </h1>
            <div className={classes.ActionDiv}>
                <span>+</span>
                <span>-</span>
            </div>
        </div>
    )
}

const BookMeal = () => {
    return (
        <div className={classes.Container}>
            <div className={classes.InputBox} >
                <label htmlFor="BookingDate">
                    Enter Date for Booking:
                </label>
                <input name="BookingDate" type="date" />
            </div>
            <div className={classes.MealType}>
                <MealType name={"Breakfast"} />
                <MealType name={"Lunch"} />
                <MealType name={"Snacks"} />
                <MealType name={"Others"} />
            </div>
        </div>
    )
}

export default BookMeal